export const errorDefault = (error) => {
  let errorMessage = ""

  if(error.response){
    if (error.response.status === 404) {
      errorMessage = "Item não encontrado."
    } else  {
      errorMessage = "Servidor indisponível no momento, tente novamente mais tarde."
    }
  } else {
    errorMessage = "Erro ao carregar os dados."
  }

  return errorMessage
}